<template>
    <div class="pdf parametric-pdf">
        <div class="pdf__container">
            <div class="pdf___header">
                <div class="pdf___header-left">
                    <div class="pdf___header-title">
                        Жилая недвижимость
                    </div>
                    <div class="pdf___header-subtitle">
                        Подборка предложений
                    </div>
                    <div class="pdf___header-count">
                        12 предложений
                    </div>
                </div>
                <div class="pdf___header-right">
                    <div class="pdf___header-label">
                        Дата предложения
                    </div>
                    <div class="pdf___header-date">
                        06.11.2024
                    </div>
                </div>
            </div>

            <div class="pdf__content pdf__content-group">
                <PdfGroup
                    :complex="flatsList[0].complex"
                    :url="flatsList[0].url"
                    :flats="flatsList.slice(0, 1)" />

                <PdfGroup
                    :complex="flatsList[1].complex"
                    :url="flatsList[1].url"
                    :flats="flatsList.slice(1, 2)" />

                <PdfGroup
                    :complex="flatsList[2].complex"
                    :url="flatsList[2].url"
                    :flats="flatsList.slice(2, 3)" />

                <PdfGroup
                    :complex="flatsList[3].complex"
                    :url="flatsList[3].url"
                    :flats="flatsList.slice(3, 4)" />
            </div>

            <div class="pdf___footer">
                <div class="pdf___footer-logo">
                    <img src="/images/logo.svg"
                         alt="Логотип">
                </div>
                <div class="pdf___footer-company">
                    Название агенства очень длинное и должно быть обрезано до 50
                    символов потому что может сдвинуться текст вниз из-за длины названия
                </div>
                <div class="pdf___footer-info">
                    <div class="pdf___footer-info-name">
                        Давлатов Егор
                    </div>
                    <div class="pdf___footer-info-phone">
                        + 7 (956) 065-32-23
                    </div>
                </div>
            </div>
        </div>

        <div class="pdf__container">
            <div class="pdf___header">
                <div class="pdf___header-right">
                    <div class="pdf___header-label">
                        Дата предложения
                    </div>
                    <div class="pdf___header-date">
                        06.11.2024
                    </div>
                </div>
            </div>

            <div class="pdf__content pdf__content-group">
                <PdfGroup
                    :complex="flatsList[4].complex"
                    :url="flatsList[4].url"
                    :flats="flatsList.slice(4, 7)" />
            </div>

            <div class="pdf___footer">
                <div class="pdf___footer-logo">
                    <img src="/images/logo.svg"
                         alt="Логотип">
                </div>
                <div class="pdf___footer-company">
                    Название агенства
                </div>
                <div class="pdf___footer-info">
                    <div class="pdf___footer-info-name">
                        Давлатов Егор
                    </div>
                    <div class="pdf___footer-info-phone">
                        + 7 (956) 065-32-23
                    </div>
                </div>
            </div>
        </div>

        <div class="pdf__container">
            <div class="pdf__content">
                <div class="pdf__project">
                    <div class="pdf__project-image">
                        <img src="/images/project-pdf.jpg"
                             alt="Spires">
                    </div>

                    <div class="pdf__project-content">
                        <div class="pdf__project-name">
                            Spires
                        </div>
                        <div class="pdf__project-text">
                            SPIRES&nbsp;&mdash; квартиры и&nbsp;урбан-виллы <br>
                            премиум-класса рядом с&nbsp;Кутузовским проспектом <br>
                            и&nbsp;природным заказником &laquo;Долина реки Сетунь&raquo;.
                        </div>
                        <ul class="pdf__project-props">
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Авторская коллекция квартир</span>
                                <span class="pdf__project-prop-text">
                                    В&nbsp;SPIRES собрана исключительная коллекция квартир. С&nbsp;высокими
                                    потолками и&nbsp;отдельным входом. С&nbsp;открытыми террасами и&nbsp;панорамными
                                    окнами. С&nbsp;каминами и&nbsp;вторым светом.
                                </span>
                            </li>
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Продуманное благоустройство</span>
                                <span class="pdf__project-prop-text">
                                    Проект благоустройства создали специалисты бюро GAFA Architects&nbsp;&mdash;
                                    признанные мастера объединять природу, инновации и&nbsp;городскую среду.
                                </span>
                            </li>
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Дизайнерские входные группы</span>
                                <span class="pdf__project-prop-text">
                                    Интерьер лобби&nbsp;&mdash; современная и&nbsp;облегченная интерпретация ар-деко.
                                    Дизайнеры бюро HAAST переосмыслили характерные для стиля узоры,
                                    орнаменты и&nbsp;металлические элементы.
                                </span>
                            </li>
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Безопасность</span>
                                <span class="pdf__project-prop-text">
                                    В&nbsp;SPIRES&nbsp;&mdash; двор без машин и&nbsp;огороженная территория,
                                    возможность открытия дверей через мобильное приложение, верификация при
                                    доступе на&nbsp;этаж.
                                </span>
                            </li>
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Паркинг и&nbsp;кладовые</span>
                                <span class="pdf__project-prop-text">
                                    Большой трёхуровневый паркинг в&nbsp;комплексе насчитывает 678
                                    машиномест&nbsp;&mdash; в&nbsp;том числе, с&nbsp;увеличенными
                                    габаритами для автомобилей представительского класса.
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="pdf__container pdf__container_theme_blue pdf__container_theme_multilevel">
            <div class="pdf__content">
                <div class="pdf__flat-detail">
                    <div class="pdf__flat-detail-media">
                        <div class="pdf__flat-detail-plan">
                            <img src="/images/pdf/plan.png"
                                 alt="план">
                        </div>
                        <div class="pdf__flat-detail-image">
                            <img src="/images/pdf/flat.png"
                                 alt="квартира">
                        </div>
                        <div class="pdf__flat-detail-image">
                            <img src="/images/pdf/flat.png"
                                 alt="квартира">
                        </div>
                    </div>

                    <div class="pdf__flat-detail-content">
                        <div class="pdf__flat-detail-name">
                            Двухуровневая 3-к квартира №56
                        </div>
                        <div class="pdf__flat-detail-info">
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Площадь
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    150.0 м²
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Корпус
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    2
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Секция
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    1
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Этаж
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    4
                                </div>
                            </div>
                        </div>

                        <div class="pdf__flat-detail-info">
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Ввод в эксплуатацию
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    I квартал 2024г
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Цена за кв.м
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    150 000 ₽
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item pdf__flat-detail-price">
                                <div class="pdf__flat-detail-info-label">
                                    Стоимость квартиры
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    <div class="pdf__flat-detail-price-old">
                                        28 230 000  ₽
                                    </div>
                                    <div class="pdf__flat-detail-price-value">
                                        23 230 000 ₽
                                    </div>
                                    <div class="pdf__flat-detail-price-sale">
                                        -25%
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pdf__flat-detail-props">
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/terrace.svg">
                                </div>
                                Терраса
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/sauna.svg">
                                </div>
                                Сауна
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/window.svg">
                                </div>
                                Окно в ванной
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/input.svg">
                                </div>
                                Отдельный вход
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/city.svg">
                                </div>
                                CityHouse
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/floor.svg">
                                </div>
                                DoubleFloor
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/wardrobe.svg">
                                </div>
                                Окно в гардеробной
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/topfloor.svg">
                                </div>
                                TopFloor
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/two-level.svg">
                                </div>
                                Двухуровневая
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/penthouse.svg">
                                </div>
                                Пентхаус
                            </div>
                        </div>
                        <div class="pdf__flat-detail-date">
                            Предложение не&nbsp;является офертой<br>
                            06.11.2024
                        </div>
                    </div>
                </div>
            </div>

            <div class="pdf___footer">
                <div class="pdf___footer-logo">
                    <img src="/images/logo.svg"
                         alt="Логотип">
                </div>
                <div class="pdf___footer-company">
                    Название агенства
                </div>
                <div class="pdf___footer-info">
                    <div class="pdf___footer-info-name">
                        Давлатов Егор
                    </div>
                    <div class="pdf___footer-info-phone">
                        + 7 (956) 065-32-23
                    </div>
                </div>
            </div>
        </div>

        <div class="pdf__container pdf__container_theme_blue">
            <div class="pdf__content">
                <div class="pdf__flat-detail">
                    <div class="pdf__flat-detail-media">
                        <div class="pdf__flat-detail-plan">
                            <img src="/images/pdf/plan.png"
                                 alt="план">
                        </div>
                        <div class="pdf__flat-detail-image">
                            <img src="/images/pdf/flat.png"
                                 alt="квартира">
                        </div>
                    </div>

                    <div class="pdf__flat-detail-content">
                        <div class="pdf__flat-detail-name">
                            3-к квартира №56
                        </div>
                        <div class="pdf__flat-detail-info">
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Площадь
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    150.0 м²
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Корпус
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    2
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Секция
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    1
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Этаж
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    4
                                </div>
                            </div>
                        </div>

                        <div class="pdf__flat-detail-info">
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Ввод в эксплуатацию
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    I квартал 2024г
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Цена за кв.м
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    150 000 ₽
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item pdf__flat-detail-price">
                                <div class="pdf__flat-detail-info-label">
                                    Стоимость квартиры
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    <div class="pdf__flat-detail-price-old">
                                        28 230 000  ₽
                                    </div>
                                    <div class="pdf__flat-detail-price-value">
                                        23 230 000 ₽
                                    </div>
                                    <div class="pdf__flat-detail-price-sale">
                                        -25%
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pdf__flat-detail-props">
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/terrace.svg">
                                </div>
                                Терраса
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/sauna.svg">
                                </div>
                                Сауна
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/window.svg">
                                </div>
                                Окно в ванной
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/input.svg">
                                </div>
                                Отдельный вход
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/city.svg">
                                </div>
                                CityHouse
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/floor.svg">
                                </div>
                                DoubleFloor
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/wardrobe.svg">
                                </div>
                                Окно в гардеробной
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/topfloor.svg">
                                </div>
                                TopFloor
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/two-level.svg">
                                </div>
                                Двухуровневая
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/penthouse.svg">
                                </div>
                                Пентхаус
                            </div>
                        </div>
                        <div class="pdf__flat-detail-date">
                            Предложение не&nbsp;является офертой<br>
                            06.11.2024
                        </div>
                    </div>
                </div>
            </div>

            <div class="pdf___footer">
                <div class="pdf___footer-logo">
                    <img src="/images/logo.svg"
                         alt="Логотип">
                </div>
                <div class="pdf___footer-company">
                    Название агенства
                </div>
                <div class="pdf___footer-info">
                    <div class="pdf___footer-info-name">
                        Давлатов Егор
                    </div>
                    <div class="pdf___footer-info-phone">
                        + 7 (956) 065-32-23
                    </div>
                </div>
            </div>
        </div>

        <div class="pdf__container">
            <div class="pdf__content">
                <div class="pdf__project">
                    <div class="pdf__project-content">
                        <div class="pdf__project-name">
                            Spires
                        </div>
                        <div class="pdf__project-text">
                            SPIRES&nbsp;&mdash; квартиры и&nbsp;урбан-виллы <br>
                            премиум-класса рядом с&nbsp;Кутузовским проспектом <br>
                            и&nbsp;природным заказником &laquo;Долина реки Сетунь&raquo;.
                        </div>
                        <ul class="pdf__project-props">
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Авторская коллекция квартир</span>
                                <span class="pdf__project-prop-text">
                                    В&nbsp;SPIRES собрана исключительная коллекция квартир. С&nbsp;высокими
                                    потолками и&nbsp;отдельным входом. С&nbsp;открытыми террасами и&nbsp;панорамными
                                    окнами. С&nbsp;каминами и&nbsp;вторым светом.
                                </span>
                            </li>
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Продуманное благоустройство</span>
                                <span class="pdf__project-prop-text">
                                    Проект благоустройства создали специалисты бюро GAFA Architects&nbsp;&mdash;
                                    признанные мастера объединять природу, инновации и&nbsp;городскую среду.
                                </span>
                            </li>
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Дизайнерские входные группы</span>
                                <span class="pdf__project-prop-text">
                                    Интерьер лобби&nbsp;&mdash; современная и&nbsp;облегченная интерпретация ар-деко.
                                    Дизайнеры бюро HAAST переосмыслили характерные для стиля узоры,
                                    орнаменты и&nbsp;металлические элементы.
                                </span>
                            </li>
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Безопасность</span>
                                <span class="pdf__project-prop-text">
                                    В&nbsp;SPIRES&nbsp;&mdash; двор без машин и&nbsp;огороженная территория,
                                    возможность открытия дверей через мобильное приложение, верификация при
                                    доступе на&nbsp;этаж.
                                </span>
                            </li>
                            <li class="pdf__project-prop">
                                <span class="pdf__project-prop-title">Паркинг и&nbsp;кладовые</span>
                                <span class="pdf__project-prop-text">
                                    Большой трёхуровневый паркинг в&nbsp;комплексе насчитывает 678
                                    машиномест&nbsp;&mdash; в&nbsp;том числе, с&nbsp;увеличенными
                                    габаритами для автомобилей представительского класса.
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="pdf__container pdf__container_theme_blue">
            <div class="pdf__content">
                <div class="pdf__flat-detail">
                    <div class="pdf__flat-detail-content">
                        <div class="pdf__flat-detail-name">
                            3-к квартира №56
                        </div>
                        <div class="pdf__flat-detail-info">
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Площадь
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    150.0 м²
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Корпус
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    2
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Секция
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    1
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Этаж
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    4
                                </div>
                            </div>
                        </div>

                        <div class="pdf__flat-detail-info">
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Ввод в эксплуатацию
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    I квартал 2024г
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item">
                                <div class="pdf__flat-detail-info-label">
                                    Цена за кв.м
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    150 000 ₽
                                </div>
                            </div>
                            <div class="pdf__flat-detail-info-item pdf__flat-detail-price">
                                <div class="pdf__flat-detail-info-label">
                                    Стоимость квартиры
                                </div>
                                <div class="pdf__flat-detail-info-value">
                                    <div class="pdf__flat-detail-price-old">
                                        28 230 000  ₽
                                    </div>
                                    <div class="pdf__flat-detail-price-value">
                                        23 230 000 ₽
                                    </div>
                                    <div class="pdf__flat-detail-price-sale">
                                        -25%
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="pdf__flat-detail-props">
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/terrace.svg">
                                </div>
                                Терраса
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/sauna.svg">
                                </div>
                                Сауна
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/window.svg">
                                </div>
                                Окно в ванной
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/input.svg">
                                </div>
                                Отдельный вход
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/city.svg">
                                </div>
                                CityHouse
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/floor.svg">
                                </div>
                                DoubleFloor
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/wardrobe.svg">
                                </div>
                                Окно в гардеробной
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/topfloor.svg">
                                </div>
                                TopFloor
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/two-level.svg">
                                </div>
                                Двухуровневая
                            </div>
                            <div class="pdf__flat-detail-prop">
                                <div class="pdf__flat-detail-prop-icon">
                                    <img src="/images/icons/penthouse.svg">
                                </div>
                                Пентхаус
                            </div>
                        </div>
                        <div class="pdf__flat-detail-date">
                            Предложение не&nbsp;является офертой<br>
                            06.11.2024
                        </div>
                    </div>
                </div>
            </div>

            <div class="pdf___footer">
                <div class="pdf___footer-logo">
                    <img src="/images/logo.svg"
                         alt="Логотип">
                </div>
                <div class="pdf___footer-company">
                    Название агенства
                </div>
                <div class="pdf___footer-info">
                    <div class="pdf___footer-info-name">
                        Давлатов Егор
                    </div>
                    <div class="pdf___footer-info-phone">
                        + 7 (956) 065-32-23
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {flats} from '@/pages/Pdf/data';
import PdfGroup from '@/pages/Pdf/templates/PdfGroup.vue';

export default {
    name: 'ParametricPdf',

    components: {
        PdfGroup
    },

    data() {
        return {
            flatsList: flats
        };
    }
};
</script>

<style lang="scss">
@import "Pdf";
</style>

<style type="text/css" media="print">
@page {
    size: A4;
    margin: 0;
}

.main {
    padding-top: 0;
    margin-top: 0;
    margin-bottom: 0;
}
</style>
